import { Controller } from "@hotwired/stimulus"
import getVideoId from "get-video-id"

// Constants
import { SUPPORTED_SERVICES, ERROR_MESSAGES, CSS_CLASSES, YOUTUBE_BASE_URL } from "../constants/video_url_constants"

// Connects to data-controller="get-video-id"
export default class extends Controller {
  static targets = ["videoInput", "videoId"]

  connect() {
    this.supportedServices = SUPPORTED_SERVICES
    this.videoInputTarget.addEventListener("input", this.handleInput.bind(this))
    if (this.videoIdTarget.value) {
      this.setYoutubeUrl(this.videoIdTarget.value)
    }
  }

  setYoutubeUrl(videoId) {
    this.videoInputTarget.value = YOUTUBE_BASE_URL + videoId
  }

  handleInput(event) {
    const videoUrl = event.target.value.trim()
    console.log("videoUrl", videoUrl)
    
    if (videoUrl === "") {
      this.videoIdTarget.value = ""
      this.clearValidation()
      return
    }

    const validation = this.validateVideoUrl(videoUrl)
    
    if (validation.isValid) {
      this.handleValidInput(validation)
    } else {
      this.handleInvalidInput(validation)
    }
  }

  validateVideoUrl(videoUrl) {
    const result = getVideoId(videoUrl)
    
    if (!result.id) {
      return {
        isValid: false,
        error: ERROR_MESSAGES.INVALID_FORMAT,
        videoId: null,
        service: null
      }
    }

    if (!this.supportedServices.includes(result.service)) {
      return {
        isValid: false,
        error: ERROR_MESSAGES.UNSUPPORTED_SERVICE(result.service),
        videoId: result.id,
        service: result.service
      }
    }

    return {
      isValid: true,
      error: null,
      videoId: result.id,
      service: result.service
    }
  }

  handleValidInput(validation) {
    this.videoIdTarget.value = validation.videoId
    this.clearValidation()
  }

  handleInvalidInput(validation) {
    this.videoIdTarget.value = ""
    this.setInvalidState(validation.error)
  }

  setInvalidState(errorMessage) {
    this.videoInputTarget.classList.add(CSS_CLASSES.INVALID)
    this.videoInputTarget.setCustomValidity(errorMessage)
    this.videoInputTarget.reportValidity()
  }

  clearValidation() {
    this.videoInputTarget.classList.remove(CSS_CLASSES.INVALID)
    this.videoInputTarget.setCustomValidity("")
  }
}
